module.exports = __webpack_public_path__ + "c6f2d31b89210365e81f417dbcb31e69.svg";